import styled from '@themes/theme'

export const TipDetailWrap = styled.div`
  width: 100%;
  img {
    width: 100%;
    height: auto;
  }
`
